import React from "react";
import LeadsManagementSection from "./LeadsManagementSection";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Bot,
  Settings,
  Users,
  MessageSquare,
  ArrowRight,
  Zap,
  Code,
  Database,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const AIAssistantPage = ({
  session,
  profile,
}: {
  session: any;
  profile: any;
}) => {
  const navigate = useNavigate();

  // Only keep Setup & Customise for top buttons
  const setupButton = {
    title: "Setup & Customise",
    icon: <Settings className="h-6 w-6 mr-2" />,
    path: "/dashboard/chatbot/setup",
  };
  const aiTrainingButton = {
    title: "AI Training",
    icon: null,
    path: "/dashboard/knowledge",
  };

  const featureCards = [
    {
      title: "Instant Responses",
      description: "Provide 24/7 support to visitors with AI-powered responses",
      icon: <Zap className="h-6 w-6" />,
      color: "text-amber-500",
    },
    {
      title: "Lead Capture",
      description: "Convert visitors into leads with smart conversation flows",
      icon: <Users className="h-6 w-6" />,
      color: "text-blue-500",
    },
    {
      title: "Easy Integration",
      description: "Embed on your website with a simple code snippet",
      icon: <Code className="h-6 w-6" />,
      color: "text-purple-500",
    },
    {
      title: "Knowledge Base",
      description:
        "Train your assistant with your organization's unique information",
      icon: <Database className="h-6 w-6" />,
      color: "text-green-500",
    },
  ];

  return (
    <div className="space-y-6">
      <div className="mb-8 flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold mb-2">Coraa AI Co-Pilot</h1>
          <p className="text-muted-foreground">
            Engage visitors, answer questions, and capture leads with your
            AI-powered assistant
          </p>
        </div>

        <div className="flex gap-4">
          <Button
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold shadow px-6 py-3 rounded-lg flex items-center"
            onClick={() => navigate(setupButton.path)}
          >
            {setupButton.icon}
            {setupButton.title}
          </Button>
          <Button
            className="bg-green-600 hover:bg-green-700 text-white font-bold shadow px-6 py-3 rounded-lg"
            onClick={() => navigate(aiTrainingButton.path)}
          >
            {aiTrainingButton.title}
          </Button>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Key Features</CardTitle>
          <CardDescription>
            Discover what your AI assistant can do for your organization
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {featureCards.map((feature, index) => (
              <div key={index} className="flex gap-4 items-start">
                <div
                  className={`p-2 rounded-full bg-slate-100 ${feature.color}`}
                >
                  {feature.icon}
                </div>
                <div>
                  <h3 className="font-medium mb-1">{feature.title}</h3>
                  <p className="text-sm text-muted-foreground">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Leads Management Section */}
      <LeadsManagementSection session={session} profile={profile} />
    </div>
  );
};

export default AIAssistantPage;
